import { useQuery, useIsMutating } from "@tanstack/react-query"

import { chat } from "@/components/CopilotAnalyze/api"
import { useCopilotAuth } from "@/components/CopilotAnalyze/CopilotAuth"

/***********************************************************************************************************************
 * Query Keys
 **********************************************************************************************************************/
export const copilotKeys = {
    // All - for things like bulk cache invalidation
    all: [{ scope: "copilot" }] as const,

    // Sessions
    sessions: () => [{ ...copilotKeys.all[0], entity: "sessions" }] as const,
    session: (id: string) => [{ ...copilotKeys.sessions()[0], ...(id ? { id } : {}) }] as const,

    // Sessions Mutations
    mutateSession: (sessionId?: string) => [{ ...copilotKeys.session(sessionId)[0], mutation: "sendMessage" }] as const,

    // Customizations
    copilotCustomizations: () => [{ ...copilotKeys.all[0], entity: "copilotCustomizations" }] as const,
    copilotCustomization: (id: string) =>
        [{ ...copilotKeys.copilotCustomizations()[0], ...(id ? { id } : {}) }] as const,
}

export const useCopilotSessions = () => {
    const { jwt } = useCopilotAuth()
    const isMutating = useIsMutating({ mutationKey: copilotKeys.mutateSession() })

    return useQuery({
        // eslint-disable-next-line @tanstack/query/exhaustive-deps -- Ignore the JWT - it is a constant
        queryKey: copilotKeys.sessions(),
        queryFn: () => chat.fetchHistory(jwt),
        // Avoid refetching while a new message has been optimistically added
        enabled: !isMutating && Boolean(jwt),
        staleTime: Infinity,
    })
}
